import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatEnum } from '../../../enum/date-format.enum';
import { VoipInternalModel } from '../../../models/entity/voip-internal.model';
import { VoipImportFromSantralRequest } from '../../../models/rest/voip/voip-import-from-santral-request';
import { AlertifyService } from '../../../services/core/alertify.service';
import { VoipInternalService } from '../../../services/voip/voip-internal.service';
import { DateUtils } from '../../../utils/date.utils';

@Component({
  selector: 'app-voip-call-import-from-server-modal',
  templateUrl: './voip-call-import-from-server-modal.component.html',
  styleUrls: ['./voip-call-import-from-server-modal.component.css']
})
export class VoipCallImportFromServerModalComponent implements OnInit {

  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  voipInternals: VoipInternalModel[] = [];
  request: VoipImportFromSantralRequest = new VoipImportFromSantralRequest();
  dateFormatEnum = DateFormatEnum;

  isActive: boolean = true;
  constructor(
    private voipInternalService: VoipInternalService,
    private translate: TranslateService,
    private alertifyService: AlertifyService) { }

  ngOnInit(): void {
    this.getVoipInternals();
    this.request.startDate = DateUtils.getToday();
    this.request.endDate = DateUtils.getToday();

  }
  getVoipInternals() {
    this.voipInternalService.getVoipInternals().subscribe(
      res => {
        this.voipInternals = res;
        if (this.voipInternals.length == 1)
          this.request.voipInternalId = this.voipInternals[0].id;
      },
      err => this.alertifyService.error(err)
    );
  }


  //güncelle veya yeni kayıt ekle
  save() {
    if (!this.validateSave())
      return;

    this.importFromSantral();
  }

  //kontroller
  validateSave() {

    return true;
  }

  // yeni kayıt ekle
  importFromSantral() {
    this.voipInternalService.importFromSantral(this.request).subscribe(
      (res) => {
        this.alertifyService.success(this.translate.instant('message.info.saved'));
        this.passEntry.emit(true);

      },
      (err) => {
        this.alertifyService.error(err);
      }
    );
  }

  close() {
    this.passEntry.emit();
  }

}
